function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) =>
/*#__PURE__*/
React.createElement("svg", _extends({
  viewBox: "0 0 60 60"
}, props),
/*#__PURE__*/
React.createElement("g", {
  fill: "#639"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M51 12.2c0-.9-.3-1.6-.9-2.2-.7-.7-1.4-1-2.3-1H12.2c-.9 0-1.6.3-2.2 1-.7.6-1 1.3-1 2.2v35.6c0 .9.3 1.6.9 2.2.6.6 1.3.9 2.2.9H40l11-12.7v-26zm-41.3 0c0-.7.2-1.3.7-1.7.5-.5 1.1-.7 1.7-.7h35.6c.7 0 1.3.2 1.7.7.5.5.7 1.1.7 1.7v6.2H9.7v-6.2zM39 50.3H12.2c-.7 0-1.3-.2-1.7-.7-.5-.5-.7-1.1-.7-1.7V19.1h40.6v18.1h-8.1c-.9 0-1.6.3-2.2.9-.6.6-.9 1.3-.9 2.2v10zm.7.1V40.3c0-.7.2-1.3.7-1.7.5-.5 1.1-.7 1.7-.7h8.2L39.7 50.4z"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M24 25.9h21.3v.7H24zM19.1 28.5V24h-4.4v4.4h4.4zm-3.8-3.8h3.1v3.1h-3.1v-3.1zM24 33.4h11.9v.7H24zM19.1 36v-4.4h-4.4V36h4.4zm-3.8-3.8h3.1v3.1h-3.1v-3.1zM24 40.9h10v.7H24zM19.1 43.5V39h-4.4v4.4h4.4zm-3.8-3.8h3.1v3.1h-3.1v-3.1z"
}))));